var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('Icon',{attrs:{"type":"ios-loading","size":"50","spin":""}}),_c('p',[_vm._v("正在验证授权...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }